import { getBonByCode, sendProforma, executeBon, getProformaData} from '../../services/OptiqueService';
import { errorToastr, successToastr } from '../../Utils/ToastrMessage';


export const GET_BON_CONFIRMED_ACTION = '[getOptBon action] confirmed getOptBon';
export const GET_BON_FAILED_ACTION = '[getOptBon action] failed getOptBon';

export const GET_PROFORMA_DATA_CONFIRMED_ACTION = '[getOpticProformaData action] confirmed getOpticProformaData';
export const GET_PROFORMA_DATA_FAILED_ACTION = '[getOpticProformaData action] failed getOpticProformaData';

export const SEND_PROFORMA_CONFIRMED_ACTION = '[getSendProforma action] confirmed getSendProforma';
export const SEND_PROFORMA_FAILED_ACTION = '[getSendProforma action] failed getSendProforma';

export const EXECUTE_ACT_CONFIRMED_ACTION = '[executeAct action] confirmed executeAct';
export const EXECUTE_ACT_FAILED_ACTION = '[executeAct action] failed executeAct';

export const START_LOADER_ACTION = '[optiqueLoader action] started optiqueLoader';

var I18n = require('react-redux-i18n').I18n;

export const getBonByCodeAction = (code) => {
    
    return (dispatch) => {
        getBonByCode(code)
        .then((response) => {
            
            dispatch(confirmedGetBonAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('labo.get_bon_error')+error.response?.data?.message);
            dispatch(getBonFailedAction(error.response?.data?.message));
        });
    };
};

export const getProformaDataAction = (code, providerId, ecartPupillaire, baseVerre) => {
    
    return (dispatch) => {
        getProformaData(code, providerId, ecartPupillaire, baseVerre)
        .then((response) => {
            
            dispatch(confirmedGetProformaDataAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('labo.get_bon_error')+error.response?.data?.message);
            dispatch(getBonFailedAction(error.response?.data?.message));
        });
    };
};

export const sendProformaAction = (data) => {
    
    return (dispatch) => {
        sendProforma(data)
        .then((response) => {
            
            successToastr(I18n.t('optic.success_proforma_send'));
            dispatch(confirmedSendProformaAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('optic.error_proforma_send')+error.response?.data?.message);
            dispatch(sendProformaFailedAction(error.response?.data?.message));
        });
    };
};

export const executeBonAction = (data) => {
    
    return (dispatch) => {
        executeBon(data)
        .then((response) => {
            
            successToastr(I18n.t('optic.success_exec_bon'));
            dispatch(confirmedExecuteBonAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('optic.error_exec_bon')+error.response?.data?.message);
            dispatch(executeBonFailedAction(error.response?.data?.message));
        });
    };
};

export function confirmedGetProformaDataAction(payload) {
    return {
        type: GET_PROFORMA_DATA_CONFIRMED_ACTION,
        payload,
    };
};

export function confirmedExecuteBonAction(payload) {
    return {
        type: EXECUTE_ACT_CONFIRMED_ACTION,
        payload,
    };
};

export function executeBonFailedAction(payload) {
    return {
        type: EXECUTE_ACT_FAILED_ACTION,
        payload,
    };
};

export function confirmedGetBonAction(payload) {
    return {
        type: GET_BON_CONFIRMED_ACTION,
        payload,
    };
};

export function getBonFailedAction(payload) {
    return {
        type: GET_BON_FAILED_ACTION,
        payload,
    };
};

export function confirmedSendProformaAction(payload) {
    return {
        type: SEND_PROFORMA_CONFIRMED_ACTION,
        payload,
    };
};

export function sendProformaFailedAction(payload) {
    return {
        type: SEND_PROFORMA_FAILED_ACTION,
        payload,
    };
};



export function startLoader() {
    return {
        type: START_LOADER_ACTION
    };
};